// extracted by mini-css-extract-plugin
module.exports = {"container":"newsLetter_container__2EclE","card":"newsLetter_card__1bnhB","link":"newsLetter_link__1ljrF"};